import React from 'react';
import Svg, {
  G,
  Path,
  Defs,
  Filter,
  FeFlood,
  FeColorMatrix,
  FeOffset,
  FeComposite,
  FeBlend,
  LinearGradient,
  Stop,
  ClipPath,
  RadialGradient,
} from 'react-native-svg';

const LeaderThreeIcon = () => {
  return (
    <Svg width={48} height={48} viewBox="0 0 48 48" fill="none">
      <Defs>
        <Filter
          id="filter0_d_313_865"
          x={3.6001}
          y={2.40039}
          width={40.8}
          height={44.15}
          filterUnits="userSpaceOnUse"
        >
          <FeFlood floodOpacity={0} result="BackgroundImageFix" />
          <FeColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <FeOffset dy={0.95} />
          <FeComposite in2="hardAlpha" operator="out" />
          <FeColorMatrix
            type="matrix"
            values="0 0 0 0 0.24 0 0 0 0 0.118652 0 0 0 0 0 0 0 0 1 0"
          />
          <FeBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_313_865"
          />
          <FeBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_313_865"
            result="shape"
          />
        </Filter>

        <LinearGradient
          id="paint0_linear_313_865"
          x1={23.9999}
          y1={54.3137}
          x2={23.9999}
          y2={2.94042}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#8C4500" />
          <Stop offset={1} stopColor="#D1A66E" />
        </LinearGradient>

        <ClipPath id="star_clip">
          <Path d="M23.1935 16.4916C23.5314 15.8361 24.4686 15.8361 24.8065 16.4916L26.953 20.6562C27.0395 20.8239 27.1761 20.9605 27.3438 21.047L31.5084 23.1935C32.1639 23.5314 32.1639 24.4686 31.5084 24.8065L27.3438 26.953C27.1761 27.0395 27.0395 27.1761 26.953 27.3438L24.8065 31.5084C24.4686 32.1639 23.5314 32.1639 23.1935 31.5084L21.047 27.3438C20.9605 27.1761 20.8239 27.0395 20.6562 26.953L16.4916 24.8065C15.8361 24.4686 15.8361 23.5314 16.4916 23.1935L20.6562 21.047C20.8239 20.9605 20.9605 20.8239 21.047 20.6562L23.1935 16.4916Z" />
        </ClipPath>

        <RadialGradient
          id="star_fill"
          cx={24}
          cy={24}
          r={8}
          gradientUnits="userSpaceOnUse"
        >
          <Stop offset="0" stopColor="white" />
          <Stop offset="1" stopColor="#E0E0E0" />
        </RadialGradient>
      </Defs>

      <G filter="url(#filter0_d_313_865)">
        {/* Main Shield Body */}
        <Path
          d="M3.6001 4.30039C3.6001 3.25105 4.45076 2.40039 5.5001 2.40039L42.5001 2.40039C43.5494 2.40039 44.4001 3.25105 44.4001 4.30039V26.1604C44.4001 36.8968 34.8801 45.6004 24.0001 45.6004C13.1201 45.6004 3.6001 36.8968 3.6001 26.1604V4.30039Z"
          fill="url(#paint0_linear_313_865)"
        />
        {/* Shield Border/Stroke Detail */}
        <Path
          d="M5.5001 2.40039L42.5001 2.40039C43.5494 2.40039 44.4001 3.25105 44.4001 4.30039V26.1604C44.4001 36.8968 34.8801 45.6004 24.0001 45.6004C13.1201 45.6004 3.6001 36.8968 3.6001 26.1604V4.30039C3.6001 3.25105 4.45076 2.40039 5.5001 2.40039Z"
          stroke="white"
          strokeOpacity={0.4}
          strokeWidth={2}
        />
      </G>

      {/* Centered Star with Gradient */}
      <Path
        clipPath="url(#star_clip)"
        d="M23.1935 16.4916C23.5314 15.8361 24.4686 15.8361 24.8065 16.4916L26.953 20.6562C27.0395 20.8239 27.1761 20.9605 27.3438 21.047L31.5084 23.1935C32.1639 23.5314 32.1639 24.4686 31.5084 24.8065L27.3438 26.953C27.1761 27.0395 27.0395 27.1761 26.953 27.3438L24.8065 31.5084C24.4686 32.1639 23.5314 32.1639 23.1935 31.5084L21.047 27.3438C20.9605 27.1761 20.8239 27.0395 20.6562 26.953L16.4916 24.8065C15.8361 24.4686 15.8361 23.5314 16.4916 23.1935L20.6562 21.047C20.8239 20.9605 20.9605 20.8239 21.047 20.6562L23.1935 16.4916Z"
        fill="url(#star_fill)"
      />

      {/* Star Outline Detail */}
      <Path
        d="M22.749 16.2627C23.2731 15.246 24.7269 15.246 25.251 16.2627L27.3975 20.4268C27.4363 20.5021 27.4979 20.5637 27.5732 20.6025L31.7373 22.749C32.754 23.2731 32.754 24.7269 31.7373 25.251L27.5732 27.3975C27.4979 27.4363 27.4363 27.4979 27.3975 27.5732L25.251 31.7373C24.7269 32.754 23.2731 32.754 22.749 31.7373L20.6025 27.5732C20.5637 27.4979 20.5021 27.4363 20.4268 27.3975L16.2627 25.251C15.246 24.7269 15.246 23.2731 16.2627 22.749L20.4268 20.6025C20.5021 20.5637 20.5637 20.5021 20.6025 20.4268L22.749 16.2627Z"
        stroke="black"
        strokeOpacity={0.16}
      />
    </Svg>
  );
};

export default LeaderThreeIcon;
